var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrashCan1818 = function SvgTrashCan1818(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B9BBBC",
    d: "M4.5 14.25c0 .825.675 1.5 1.5 1.5h6c.825 0 1.5-.675 1.5-1.5v-7.5c0-.825-.675-1.5-1.5-1.5H6c-.825 0-1.5.675-1.5 1.5zM13.5 3h-1.875l-.533-.533a.76.76 0 0 0-.524-.217H7.433a.76.76 0 0 0-.526.217L6.376 3H4.5a.75.75 0 0 0-.75.75c0 .412.338.75.75.75h9c.412 0 .75-.338.75-.75A.75.75 0 0 0 13.5 3"
  })));
};
export default SvgTrashCan1818;